import { render, staticRenderFns } from "./OrgunitList.vue?vue&type=template&id=563fb430"
import script from "./OrgunitList.vue?vue&type=script&lang=js"
export * from "./OrgunitList.vue?vue&type=script&lang=js"
import style0 from "./OrgunitList.vue?vue&type=style&index=0&id=563fb430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports